module.exports = __webpack_public_path__ + "static/media/Vinnande försäljning ws.c51fa9c1.pdf";